import { atom, selector } from 'recoil'
import { layerDefsAtomFamily } from "../layers/layerDefsAtoms";
import { selectedFocusAreaAtom } from "./selectedRegionAtoms.js"
import { layerDefs } from "../layers/layerDefs.jsx";

// TODO: Import this in drawer/DrawerHighstreetContainer.jsx
export const focusAreaLayers = [
  {
    id: layerDefs["highstreet"].layer.id,
    label: layerDefs["highstreet"].labels.parent,
  },
  {
    id: layerDefs["business-improvement-districts"].layer.id,
    label: layerDefs["business-improvement-districts"].labels.parent,
  },
  {
    id: layerDefs["town-centre-boundaries"].layer.id,
    label: layerDefs["town-centre-boundaries"].labels.parent,
  },
]

const focusAreaLayerIdAtom = atom({
	key: "focus-area-layer-id-atom",
	// NOTE: If you want to change the default you'll also need to sync the
	// default visibilities in "../layers/planningLayerDefs.js".  
	default: focusAreaLayers[0].id, // "highstreet" layer
});

export const focusAreaLayerIdSelector = selector({
	key: "focus-area-layer-id-selector",
	get: ({ get }) => get(focusAreaLayerIdAtom),
	set: ({ get, set }, selectedLayerId) => {
		const selectedFocusArea = get(selectedFocusAreaAtom);

		if (!!selectedFocusArea) {
			// Don't touch layers if a focus area is selected.
			// This selector should never trigger when it is, but just in case.
			// The drop down that triggers this code should be disabled when
			// a focus area is selected.
			return
		}

		const layer = focusAreaLayers.find((layer) => layer.id === selectedLayerId)
		if (!layer) {
			throw new Error(`'${selectedLayerId}' is not in the list of allowable focus area layers`)
		}

		setLayerAsFocusAreaLayer(set, selectedLayerId)
		set(focusAreaLayerIdAtom, selectedLayerId)
	}
})

const setLayerAsFocusAreaLayer = (set, selectedLayerId) => {
	for (const layer of focusAreaLayers) {
    set(layerDefsAtomFamily(layer.id), (layerDef) => {
    	return updateFocusAreaLayerDef(layerDef, layer.id === selectedLayerId)
    });
	}
}

const updateFocusAreaLayerDef = (layerDef, isFocusArea) => {
	return {
    ...layerDef,
    noColourPicker: isFocusArea,
    orderNumber: isFocusArea ? 0 : 1,
    layer: {
    	...layerDef.layer,
    	layout: {
    		...layerDef.layer.layout,
    		visibility: isFocusArea ? "visible" : "none",
    	}
    }
  }
}